import { API_URL, UPLOADS_URL } from "../config";
import { Capacitor } from "@capacitor/core";

const isInlineMedia = (value) =>
    /^(data:|blob:|file:|content:)/i.test(value);

const replaceLocalhostOrigin = (value) => {
    try {
        const parsed = new URL(value);
        if (["localhost", "127.0.0.1", "::1"].includes(parsed.hostname)) {
            return `${API_URL}${parsed.pathname}${parsed.search}${parsed.hash}`;
        }
    } catch (_) {
        // The value is a relative path; it is handled below.
    }
    return value;
};

const getOptimizedMobileImage = (filename) =>
    `${API_URL}/api/media/image?file=${encodeURIComponent(filename.split("/").pop())}`;

const optimizeCloudinaryImage = (value) => {
    try {
        const parsed = new URL(value);
        if (
            parsed.hostname === "res.cloudinary.com" &&
            parsed.pathname.includes("/image/upload/") &&
            !parsed.pathname.includes("/f_auto,q_auto")
        ) {
            parsed.pathname = parsed.pathname.replace(
                "/image/upload/",
                "/image/upload/f_auto,q_auto:eco,w_1080,c_limit/"
            );
        }
        return parsed.toString();
    } catch (_) {
        return value;
    }
};

export const getMediaUrl = (file, type = "image") => {
    if (!file) return "";
    const value = String(file).trim().replace(/\\/g, "/");

    if (isInlineMedia(value)) return value;

    // Keep remote/CDN media, but replace localhost URLs saved by the web app
    // with the API host selected for the native application.
    if (/^https?:\/\//i.test(value)) {
        const normalizedUrl = replaceLocalhostOrigin(value);

        try {
            const parsed = new URL(normalizedUrl);
            if (
                Capacitor.isNativePlatform() &&
                parsed.hostname === "res.cloudinary.com"
            ) {
                return optimizeCloudinaryImage(normalizedUrl);
            }
        } catch (_) {
            // Keep the normalized URL if it cannot be parsed.
        }

        return normalizedUrl;
    }

    // The API sometimes returns "uploads/..." and sometimes only a filename.
    // Supporting both formats prevents duplicated paths such as
    // /uploads/uploads/avatar.jpg on mobile.
    if (/^\/?(api\/)?uploads\//i.test(value)) {
        const relativePath = value.replace(/^\/+/, "").replace(/^api\//i, "");
        if (Capacitor.isNativePlatform() && type === "image") {
            return getOptimizedMobileImage(relativePath);
        }
        return `${API_URL}/${relativePath}`;
    }

    const filename = value.replace(/^\/+/, "");

    if (type === "video") {
        return `${UPLOADS_URL}/videos/${filename.replace(/^videos\//i, "")}`;
    }

    if (type === "document") {
        return `${UPLOADS_URL}/documents/${filename.replace(/^documents\//i, "")}`;
    }

    return Capacitor.isNativePlatform()
        ? getOptimizedMobileImage(filename)
        : `${UPLOADS_URL}/${filename}`;
};
